import { AxiosResponse } from 'axios';
import { Submissions} from '../../Model/Dto/VerificationAgency/IntegrationProcess/Submissions';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrls.IntegrationProcess';
import { SearchResult } from '../../Model/Dto/SearchResult';
import {ResultWithValue} from "../../Common/Constants/Result/ResultWithValue";
import {axiosInstance} from "../AxiosInterceptor";

export const IntegrationProcessService = {
    SearchSubmissions: (input: Submissions.SubmissionSearchInput): Promise<AxiosResponse<SearchResult<Submissions.SubmissionSearchResult>>> =>
        axiosCoreInstance.post(ApiUrls.SearchSubmissions, input),
    DeleteSubmission: (id: number): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.delete(`${ApiUrls.Submissions}/${id}`),
    HasPendingSubmission: (scorecardId: string): Promise<AxiosResponse<boolean>> =>
        axiosCoreInstance.get(`${ApiUrls.HasPendingSubmission}/${scorecardId}`),
    HasAnyPendingSubmission: (): Promise<AxiosResponse<boolean>> =>
        axiosCoreInstance.get(`${ApiUrls.HasAnyPendingSubmission}`),
    GetSubmissionDetails: (id: number): Promise<AxiosResponse<Submissions.SubmissionSearchResult>> =>
        axiosCoreInstance.get(`${ApiUrls.GetSubmissionDetails}/${id}`),
    SubmitScorecard: (input: Submissions.SubmitScorecardDto): Promise<AxiosResponse<ResultWithValue<string>>> =>
        axiosInstance.post(ApiUrls.SubmitScorecard, input),
    ProcessSubmission: (input: Submissions.SubmissionDetailDto): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.put(ApiUrls.ProcessSubmission, input),
    CopyProgressStuckCheck: (scorecardId: string): Promise<AxiosResponse<{Status: string, ExceptionMessage: string}>> =>
        axiosInstance.get(`${ApiUrls.CopyProgress}/${scorecardId}`),
    RemoveRedisKeyCheck: (scorecardId: string): Promise<AxiosResponse<ResultWithValue<boolean>>> =>
        axiosInstance.get(`${ApiUrls.RemoveKey}/${scorecardId}`),
};